var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.46,4.75c-.84,0-1.51,.68-1.51,1.51s.68,1.51,1.51,1.51c5.21,0,9.45,4.24,9.45,9.45v21.43c-2.29-2.66-5.68-4.36-9.45-4.36-5.34,0-9.89,3.38-11.67,8.11-.87-.62-1.93-.99-3.08-.99s-2.24,.38-3.11,1.01c-1.77-4.74-6.33-8.13-11.69-8.13-3.78,0-7.16,1.7-9.45,4.36V17.22c0-5.21,4.24-9.45,9.45-9.45,.84,0,1.51-.68,1.51-1.51s-.68-1.51-1.51-1.51c-6.88,0-12.48,5.6-12.48,12.48v29.55c0,6.88,5.6,12.48,12.48,12.48s12.48-5.6,12.48-12.48c0-1.28,1.04-2.32,2.32-2.32s2.27,1.04,2.27,2.32c0,6.88,5.6,12.48,12.48,12.48s12.48-5.6,12.48-12.48V17.22c0-6.88-5.6-12.48-12.48-12.48h0ZM16.91,56.23c-5.21,0-9.45-4.24-9.45-9.45s4.24-9.45,9.45-9.45,9.45,4.24,9.45,9.45c-.01,5.21-4.25,9.45-9.45,9.45Zm29.55,0c-5.21,0-9.45-4.24-9.45-9.45s4.24-9.45,9.45-9.45,9.45,4.24,9.45,9.45-4.24,9.45-9.45,9.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasses);
export default __webpack_public_path__ + "static/media/icon_glasses.a323f97a.svg";
export { ForwardRef as ReactComponent };